// Temporarily withheld from the grid. The definitions stay below so bringing
// them back is a one-line change.
export const HIDDEN_FIELDS = new Set([
  'id',
  'expectedFlow',
  'measuredFlow',
  'observedIdleFlow',
  // SCRUM-1032: Fertigation is set up on its own page; the link here is
  // withheld on /config and in the guided setup alike.
  'fertigation',
])

/**
 * SCRUM-1032: dropped from the guided setup's pipe list. State reports what the
 * hardware is doing right now — there is nothing to report on a controller
 * being set up, and it costs width the fields being entered need.
 */
export const GUIDED_HIDDEN_FIELDS = new Set(['state'])

/**
 * Why a pipe's Acknowledge is unavailable.
 *
 * Hardcoded English, pending a Tolgee key — the reset API is reached through a
 * flow VALVE (`reset-error-by-id`), so a rule with no valve has no id to reset
 * through and the row button has nothing to call.
 */
export const ACK_NO_VALVE_HINT_KEY = 'flowRuleAckNoValveHint'

export const CREATE_PIPE_ID = -2
// Pipes nest three deep; the deepest level cannot take a sub-pipe.
export const MAX_PIPE_LEVEL = 3
export const ROW_HEIGHT = 52
export const DESCRIPTION_FIELD = 'description'
export const CAPACITY_FIELD = 'capacity'

/**
 * Draft ids come from a counter seeded here and decremented per draft, so any
 * number of drafts can be staged at once without colliding — with each other,
 * or with the "+ Add New Mainline" chip row (-2), which sits far above this
 * band.
 */
export const DRAFT_ID_START = -1_000_000

// Pipe writes must be serialised: the API returns 500 under concurrent writes.
export const SAVE_RETRY_LIMIT = 3
export const SAVE_RETRY_DELAY_MS = 300
export const SAVE_REQUEST_GAP_MS = 120

export const COLUMN_CONFIG = [
  // Description lives on the tree column, so sub-pipes are indented under their
  // parent. This column keeps the ids, which stay on one vertical line because
  // it carries no tree indentation.
  {
    field: 'id',
    headerName: '#',
    minWidth: 70,
    maxWidth: 90,
    sortable: false,
    valueType: 'rowId',
  },
  {
    field: 'capacity',
    headerName: 'hydraulicColumnCapacity',
    // Wide enough for the "Capacity (l/m)" header, which is longer than any
    // value it holds. 120 was 5px short of it once the 12px cell padding was
    // taken off both sides, so the label ellipsised at the default zoom; this
    // leaves headroom for a longer unit or translation too.
    minWidth: 136,
    maxWidth: 180,
    flex: 1,
    sortable: false,
    valueType: 'flowValue',
    editable: true,
  },
  {
    field: 'status',
    headerName: 'hydraulicColumnState',
    // Holds a single short word; flexing it just starved the Flow Rule strip.
    minWidth: 90,
    maxWidth: 150,
    flex: 1,
    sortable: true,
    filter: 'set' as const,
    valueType: 'state',
  },
  // Add/remove sits with the four workspaces it governs: the add button is
  // what brings the rule into being, and the delete is what takes it and the
  // workspaces away. Splitting them across two columns hid that relationship.
  {
    field: 'rule',
    headerName: 'hydraulicColumnFlowRule',
    // The chip strip measures ~400px once the last chip reads "Valves & Pumps";
    // the leading button and its divider add ~46px, and anything narrower clips
    // that chip.
    minWidth: 490,
    maxWidth: 520,
    // Never shrink: the strip is a fixed set of controls, and clipping the
    // last chip is what made the column look broken.
    flex: 0,
    sortable: false,
    valueType: 'rule',
  },
  {
    field: 'fertigation',
    headerName: 'hydraulicColumnFertigation',
    // Holds the MANAGE button, which is wider than the header.
    minWidth: 140,
    maxWidth: 220,
    flex: 1,
    sortable: false,
    valueType: 'fertigation',
  },
  {
    field: 'expectedFlow',
    headerName: 'hydraulicColumnExpectedFlow',
    minWidth: 90,
    sortable: false,
    valueType: 'flowValue',
  },
  {
    field: 'measuredFlow',
    headerName: 'hydraulicColumnMeasuredFlow',
    minWidth: 90,
    sortable: false,
    valueType: 'flowValue',
  },
  {
    field: 'observedIdleFlow',
    headerName: 'hydraulicColumnObservedIdleFlow',
    minWidth: 95,
    sortable: false,
    valueType: 'flowValue',
  },
  {
    field: 'action',
    headerName: 'commonTableHeaderAction',
    // Fits the "+ Add Sub Pipe" and DELETE chips side by side in bulk edit.
    minWidth: 240,
    sortable: false,
    valueType: 'action',
  },
]
